import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export function useDeleteFamilyWithMembers() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, string>({
    mutationFn: (id: string) => api.delete(`families/${id}/with-members`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['families'] });
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const deleteFamilyWithMembers = async (id: string) => {
    return mutateAsync(id);
  };

  return {
    deleteFamilyWithMembers,
    error,
    isLoading,
    reset,
  };
}
